var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMapa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 3,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.531 27.591-8.057-4.065L2 28.263V7.737L11.474 3l9.473 4.737L30.421 3v14.307"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.474 3v20.526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.947 7.737v11.686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.612 28.454a4.737 4.737 0 1 0-6.698 0c.66.662 1.776 1.65 3.349 2.967 1.66-1.405 2.777-2.394 3.349-2.967h0Z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M27.263 25.105v.016"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapa);
export default __webpack_public_path__ + "static/media/ico-mapa.db0ff11355a2751dd9f4bc1a5f383ab5.svg";
export { ForwardRef as ReactComponent };